/** Free-tier guard: block creation of new project tags when at the active limit. */
// @ts-check

/** Max distinct active project tags for Free users before blocking new ones. */
export const FREE_ACTIVE_PROJECT_LIMIT = 3;

/**
 * Project terms that are not yet in the user's project catalog (case-insensitive).
 *
 * @param {string[] | null | undefined} terms
 * @param {Map<string, string>} knownProjectMap - master catalog id → display name
 * @returns {string[]}
 */
export const getNewProjectTerms = (terms, knownProjectMap) => {
  if (!terms?.length) return [];
  const known = knownProjectMap ?? new Map();
  return terms.filter((term) => {
    if (!term) return false;
    return !known.has(String(term).trim().toLowerCase());
  });
};

/**
 * Whether a Free user must be blocked from creating one or more new project tags.
 *
 * @param {{
 *   tier: import('@/features/tier/TierContext.def').UserTier,
 *   activeProjectCount: number,
 *   projectTerms: string[] | null | undefined,
 *   knownProjectMap: Map<string, string>,
 * }} params
 * @returns {boolean}
 */
export const shouldBlockNewProjectCreation = ({
  tier,
  activeProjectCount,
  projectTerms,
  knownProjectMap,
}) => {
  if (tier !== 'free') return false;
  const newTerms = getNewProjectTerms(projectTerms, knownProjectMap);
  if (newTerms.length === 0) return false;
  return activeProjectCount >= FREE_ACTIVE_PROJECT_LIMIT;
};
